export default __webpack_public_path__ + "videos/green-grid-motion-5s.mp4";